<template>
  <div class="position-relative">
    <BaseButton
      variant="naked"
      :class="[
        'menu-btn reset-btn-styling d-flex justify-content-center',
        { active: showDropdownItem },
      ]"
      @click="onMenuClick"
    >
      <MenuVerticalIcon />
    </BaseButton>

    <div
      v-if="showDropdownItem"
      class="dropdown__item position-absolute"
      @click.prevent="showModal"
    >
      {{
        reviewFromUser
          ? $label('books.reviews.deleteReviewDropdownItem')
          : $label('books.reviews.reportReviewDropdownItem')
      }}
    </div>

    <ReportInappropriateModal
      :review-uid="reviewUid"
      :report-review="reportReview"
      :hide-modal="reportInappropriateModal.hide"
    />

    <DeleteReviewModal
      :review-uid="reviewUid"
      :delete-review="deleteReview"
      :update-reviews="updateReviews"
      :hide-modal="deleteReviewModal.hide"
    />
  </div>
</template>

<script>
import MenuVerticalIcon from '~/assets/icons/menu-vertical.svg'
import ReportInappropriateModal from '~/components/reviews/ReportInappropriateModal'
import DeleteReviewModal from '~/components/reviews/DeleteReviewModal'
import { useModal } from '~/composables/useModal'

export default {
  components: {
    MenuVerticalIcon,
    ReportInappropriateModal,
    DeleteReviewModal,
  },
  props: {
    reviewUid: {
      type: String,
      default: '',
    },
    reportReview: {
      type: Function,
      required: true,
    },
    deleteReview: {
      type: Function,
      required: true,
    },
    reviewFromUser: {
      type: Boolean,
      default: false,
    },
    updateReviews: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const reviewUid = toRef(props, 'reviewUid')
    const deleteReviewModal = useModal(`deleteReview_${reviewUid.value}`)
    const reportInappropriateModal = useModal(
      `reportInappropriate_${reviewUid.value}`,
    )

    return {
      deleteReviewModal,
      reportInappropriateModal,
    }
  },
  data() {
    return {
      showDropdownItem: false,
    }
  },
  beforeUnmount() {
    document.body.removeEventListener('click', this.closeMenu)
  },
  methods: {
    onMenuClick(event) {
      event.preventDefault()
      event.stopPropagation()

      this.showDropdownItem = !this.showDropdownItem

      if (this.showDropdownItem) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    closeMenu() {
      this.showDropdownItem = false
      document.body.removeEventListener('click', this.closeMenu)
    },
    showModal() {
      if (this.reviewFromUser) {
        this.deleteReviewModal.show()
      } else {
        this.reportInappropriateModal.show()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-btn {
  border-radius: 0%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;

  &:not(:focus):hover,
  &.active {
    background: rgba(0, 0, 0, 0.1);
  }
}

.dropdown__item {
  background-color: $white;
  min-width: 213px;
  right: 0;
  padding: 8px 16px;
  z-index: 1;
  box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
</style>
